// Renderizado de "rich text" ligero para todo el contenido generado por LLM.
//
// Convención acordada en iter87: el LLM emite énfasis con `**texto**`. Este
// helper convierte esos marcadores en `<strong>` con subrayado dorado (verde
// oscuro sobre subrayado #C9A84C). El resto del texto se emite como plano
// (evita cualquier riesgo de inyección de HTML).
//
// ⚠️ REGLA DE ORO
//   TODO campo cuyo valor venga del LLM (storyline, headline, executive,
//   global_summary, global_closing, by_area, recommended_focus, reason,
//   step, intro, summary, conclusion, insight text, etc.) DEBE renderizarse
//   con `renderRich(...)`. Sin esto, los `**` aparecen literales en la UI.
//
// El test de regresión en `frontend/scripts/check-rich-usage.spec.js` (o
// backend `tests/test_iter88_rich_rendering_coverage.py`) escanea los JSX
// buscando campos conocidos que se rendericen SIN pasar por `renderRich`.

const _RICH_HL_RE = /\*\*([^*][^*]*?)\*\*/g;

/**
 * Renderiza un string plano convirtiendo los marcadores `**...**` en
 * `<strong>` con subrayado dorado. Devuelve un array de React nodes o el
 * string original si no hay marcadores.
 */
export function renderRich(text) {
  if (text == null) return null;
  const src = String(text);
  const parts = [];
  let last = 0;
  _RICH_HL_RE.lastIndex = 0;
  let m;
  while ((m = _RICH_HL_RE.exec(src)) !== null) {
    if (m.index > last) parts.push(src.slice(last, m.index));
    parts.push(
      <strong
        key={m.index}
        className="font-bold"
        style={{
          textDecoration: "underline",
          textDecorationColor: "#C9A84C",
          textDecorationThickness: "2px",
          textUnderlineOffset: "3px",
          color: "inherit",
        }}
      >
        {m[1]}
      </strong>
    );
    last = m.index + m[0].length;
  }
  if (last < src.length) parts.push(src.slice(last));
  return parts.length ? parts : src;
}
